import { Routes, Route } from 'react-router-dom';
import { VtechLayout } from './components/VtechLayout';
import { HomePage, AboutPage, HoningPage, ProductsPage, ProductDetailPage, ContactPage } from './pages';

// Drop-in <Routes> for the V-Tech site. Renders the shared layout (header, footer,
// sticky quote bar, chrome FX) around all pages.
//
// Mount at the app root:
//   import { BrowserRouter } from 'react-router-dom';
//   import { VtechRoutes } from './vtech/VtechRoutes';
//   <BrowserRouter><VtechRoutes /></BrowserRouter>
//
// To mount the whole site under a base path, wrap this in a parent route in your own
// <Routes> using a wildcard, e.g. <Route path="/v-tech/*" element={<VtechRoutes />} />,
// and set <BrowserRouter basename="/v-tech">.
//
// Props `stickyQuote` and `grain` are forwarded to the layout.
export const VtechRoutes = ({ stickyQuote = false, grain = true }) => (
  <Routes>
    <Route element={<VtechLayout stickyQuote={stickyQuote} grain={grain} />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/honing" element={<HoningPage />} />
      <Route path="/products" element={<ProductsPage />} />
      <Route path="/products/:id" element={<ProductDetailPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Route>
  </Routes>
);
